<template>
  <div>
    <Sidebar />
    <div class="content">
      <NavBar />
      <main>
        <div class="header">
          <div class="left">
            <h1>Projetos - Subestação Elétrica</h1>
          </div>
        </div>

        <div class="bottom-data">
          <div class="orders">
            <div class="header">
              <i class="bx bx-message-square-dots"></i>
              <h3>Listagem</h3>
              <router-link to="/projetos/solar/adicionar" data-bs-placement="right"
                tooltip-bs-title="Adicionar Projeto">
                <i class="bx bx-plus-circle icon-success"></i>
              </router-link>
            </div>
            <div class="tabs-container" style="display: flex; gap: 10px; margin-bottom: 20px; border-bottom: 2px solid #eee; padding-bottom: 10px;">
              <button 
                :class="['tab-button', { active: activeTab === 'ativos' }]"
                @click="activeTab = 'ativos'"
                style="padding: 10px 20px; border: none; background: none; cursor: pointer; font-weight: 500; border-bottom: 3px solid transparent;"
              >
                Ativos
              </button>
              <button 
                :class="['tab-button', { active: activeTab === 'arquivados' }]"
                @click="activeTab = 'arquivados'"
                style="padding: 10px 20px; border: none; background: none; cursor: pointer; font-weight: 500; border-bottom: 3px solid transparent;"
              >
                Arquivados
              </button>
            </div>
            <div v-if="activeTab === 'ativos'">
              <table v-if="role != 2">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nome</th>
                    <th>Criação</th>
                    <th>Situação</th>
                    <th>Pagamento</th>
                    <th>Ação</th>
                  </tr>
                </thead>
              <tbody>
                <tr v-for="project in projects" :key="project.id">
                  <td>{{ project.id }}</td>
                  <td>{{ project.project_name }}</td>
                  <td>{{ formatDate(0, project.created_at) }} </td>
                  <td>
                    <span class="status" :class="getStatusClass(project.id_state)">
                      {{ getStatusText(project.id_state) }}
                    </span>
                  </td>
                  <td>
                    <span class="status" :class="statusPay(project.payment_status)">
                      {{ getStatusPay(project.payment_status) }}
                    </span>
                  </td>
                  <td class="actions-icon">
                    <router-link :to="{ name: 'project-manager', params: { projeto: project.id } }">
                      <span data-bs-toggle="tooltip" tooltip-bs-title="Ver detalhes do projeto"
                        class="bx bx-detail ml-5 mr-5 icon-primary">
                      </span>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-show="role == 2" v-for="(item, index) in projects" :key="index" class="accordion-item">
              <button @click="toggle(index)" class="accordion-header">
                {{ item.full_name }}
              </button>
              <div v-show="activeIndex === index" class="accordion-content">
                <table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nome</th>
                      <th>Criação</th>
                      <th>Situação</th>
                      <th>Pagamento</th>
                      <th>Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="project in item.listProject" :key="project.id">
                      <td>{{ project.id }}</td>
                      <td>{{ project.project_name }}</td>
                      <td>{{ formatDate(0, project.created_at) }} </td>
                      <td>
                        <span class="status" :class="getStatusClass(project.id_state)">
                          {{ getStatusText(project.id_state) }}
                        </span>
                      </td>
                      <td>
                        <span class="status" :class="getStatusClass(project.payment_status)">
                          {{ statusPay(project.payment_status) }}
                        </span>
                      </td>
                      <td class="actions-icon">
                        <router-link :to="{ name: 'project-manager', params: { projeto: project.id } }">
                          <span data-bs-toggle="tooltip" tooltip-bs-title="Ver detalhes do projeto"
                            class="bx bx-detail ml-5 mr-5 icon-primary">
                          </span>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            </div>
            <div v-else>
              <table v-if="role != 2">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nome</th>
                    <th>Criação</th>
                    <th>Pagamento</th>
                    <th>Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="project in archivedProjects" :key="project.id">
                    <td>{{ project.id }}</td>
                    <td>{{ project.project_name }}</td>
                    <td>{{ formatDate(0, project.created_at) }} </td>
                    <td>
                      <span class="status" :class="statusPay(project.payment_status)">
                        {{ getStatusPay(project.payment_status) }}
                      </span>
                    </td>
                    <td class="actions-icon">
                      <router-link :to="{ name: 'project-manager', params: { projeto: project.id } }">
                        <span data-bs-toggle="tooltip" tooltip-bs-title="Ver detalhes do projeto"
                          class="bx bx-detail ml-5 mr-5 icon-primary">
                        </span>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-show="role == 2" v-for="(item, index) in archivedProjects" :key="index" class="accordion-item">
                <button @click="toggleArchived(index)" class="accordion-header">
                  {{ item.full_name }}
                </button>
                <div v-show="activeArchivedIndex === index" class="accordion-content">
                  <table>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Nome</th>
                        <th>Criação</th>
                        <th>Pagamento</th>
                        <th>Ação</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="project in item.listProject" :key="project.id">
                        <td>{{ project.id }}</td>
                        <td>{{ project.project_name }}</td>
                        <td>{{ formatDate(0, project.created_at) }} </td>
                        <td>
                          <span class="status" :class="statusPay(project.payment_status)">
                            {{ getStatusPay(project.payment_status) }}
                          </span>
                        </td>
                        <td class="actions-icon">
                          <router-link :to="{ name: 'project-manager', params: { projeto: project.id } }">
                            <span data-bs-toggle="tooltip" tooltip-bs-title="Ver detalhes do projeto"
                              class="bx bx-detail ml-5 mr-5 icon-primary">
                            </span>
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import Cookie from 'js-cookie'
import NavBar from "@/components/NavBar.vue";
import Sidebar from "@/components/SideBar.vue";

export default {
  components: {
    NavBar,
    Sidebar
  },
  data() {
    return {
      projects: [],
      author: "",
      token: "",
      activeIndex: null,
      activeTab: 'ativos',
      archivedProjects: [],
      filteredArchivedProjects: [],
      activeArchivedIndex: null,
      role: this.$store.state.role
    };
  },
  methods: {
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    toggleArchived(index) {
      this.activeArchivedIndex = this.activeArchivedIndex === index ? null : index;
    },
    load() {
      this.$http
        .get("user/projects/list/4", {
          headers: {
            "Authorization": "Bearer " + this.token
          },
        })
        .then((response) => {
          const data = response.data.projects || [];
          if (this.role == 2) {
            const groups = data;
            this.projects = groups
              .map((g) => ({ ...g, listProject: (g.listProject || []).filter(p => p.id_state != 11) }))
              .filter(g => g.listProject && g.listProject.length > 0);
            this.archivedProjects = groups
              .map((g) => ({ ...g, listProject: (g.listProject || []).filter(p => p.id_state == 11) }))
              .filter(g => g.listProject && g.listProject.length > 0);
          } else {
            this.projects = data.filter(p => p.id_state != 11);
            this.archivedProjects = data.filter(p => p.id_state == 11);
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            this.showAlert('error', error.response.data);
          } else {
            this.showAlert('error', 'Ocorreu um erro desconhecido. Entre em contato com a equipe de desenvolvimento.');
          }
        });
    },
    showAlert(type, msg) {
      var textMsg = "";

      if (msg.message) {


        if (typeof msg.errors === 'object' && msg.errors) {
          for (const key in msg.errors) {
            if (Object.prototype.hasOwnProperty.call(msg.errors, key)) {
              const errorMessages = msg.errors[key];
              textMsg += `${errorMessages.join(', ')}<br>`;
            }
          }
        } else {
          textMsg = `${msg.message}`;
        }
      } else {
        textMsg = `${msg}`;
      }

      this.$swal({
        text: textMsg,
        icon: type,
        confirmButtonText: 'Confirmar',
        html: textMsg
      });
    },
    formatDate(type, date) {
      if (!date) {
        return '';
      }

      const dateFormat = new Date(date);

      if (type == 0) {
        return `${dateFormat.getDate().toString().padStart(2, '0')}/${(dateFormat.getMonth() + 1).toString().padStart(2, '0')}/${dateFormat.getFullYear()}`;
      } else {

        return `${dateFormat.getDate().toString().padStart(2, '0')}/${(dateFormat.getMonth() + 1).toString().padStart(2, '0')}/${dateFormat.getFullYear()} às ${dateFormat.getHours().toString().padStart(2, '0')}:${dateFormat.getMinutes().toString().padStart(2, '0')}`;
      }

    },
    getStatusClass(status) {
      switch (status) {
        case 1:
          return 'dark-grey';
        case 2:
          return 'light-warning';
        case 3:
          return 'pending';
        case 4:
          return 'warning';
        case 5:
          return 'danger';
        case 6:
          return 'success';
        case 7:
        case 10:
          return 'primary';
        case 8:
          return 'completed';
        case 9:
          return 'cancelled';
      }
    },
    getTypeProject(status) {
      switch (status) {
        case '1':
          return 'Solar';
        case '2':
          return 'Medição Agrupada';
        case '3':
          return 'Eletrico Predial';
        case '4':
          return 'Subestação';
      }
    },
    getStatusText(status) {
      switch (status) {
        case 1:
          return 'Aberto';
        case 2:
          return 'Em progresso';
        case 3:
          return 'Protocolado';
        case 4:
          return 'Em Parecer de Acesso';
        case 5:
          return 'Obra em andamento';
        case 6:
          return 'Aprovado';
        case 7:
          return 'Vistoria solicitada';
        case 8:
          return 'Finalizado';
        case 9:
          return 'Cancelado';
      }
    },
    statusPay(status) {
      switch (status) {
        case 1:
          return 'warning';
        case 2:
          return 'light-warning';
        case 3:
          return 'pending';
        case 4:
          return 'success';
      }
    },
    getStatusPay(status) {
      switch (status) {
        case 1:
          return 'Aguardando Pagamento 1/2';
        case 2:
          return 'Pagamento Confirmado 1/2';
        case 3:
          return 'Aguardando Pagamento 2/2';
        case 4:
          return 'Pago';
      }
    },
    // archived projects are derived from the result of `load()` by filtering id_state === 11

  },
  created() {
    if (Cookie.get('_token')) {

      this.token = Cookie.get('_token')
    }
    this.load();
  },
};
</script>
<style scoped>
.tab-button {
  padding: 10px 20px;
  border: none;
  background: none;
  cursor: pointer;
  font-weight: 500;
  border-bottom: 3px solid transparent;
  color: #333;
  transition: all 0.3s ease;
}

.tab-button:hover {
  color: #007bff;
}

.tab-button.active {
  color: #007bff;
  border-bottom-color: #007bff;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #999;
}
</style>